/** Маршрути екранів входу (поза оболонкою простору; basename (база збірки) додає router): вхід, реєстрація, створення простору, спостерігач. */
export const authRoutes = {
  login: () => '/login',
  register: () => '/register',
  onboarding: () => '/onboarding',
  observe: () => '/observe',
};
